var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-chip-group',{attrs:{"items":_vm.groups,"hide-details":true,"hide-selected":"","multiple":"","chips":""}},[_vm._l((_vm.groups),function(group,i){return [_c('v-chip',{key:'chip' + i,attrs:{"small":""}},[_vm._v(_vm._s(group.text))])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }